import LanguageSelector from "../components/LanguageSelector";
import BeginButton from "../components/Home/BeginButton";
import BackgroundImage from "../components/Home/BackgroundImage";
import Title from "../components/Home/TitleAndDescription";
import Description from "../components/Home/Description";
import LoginButton from "../components/Home/Login";
import ContactFooter from "../components/Home/ContactFooter";
import Company from "../components/Home/Company";
import { useMode } from "../context/useMode";
import { detectMode } from "../utils/modeDetection";
import { useEffect } from "react";

const Home = () => {
  const { mode, setMode } = useMode();

  // Detect and set mode based on subdomain and query parameters
  useEffect(() => {
    const detectedMode = detectMode();
    if (detectedMode !== mode) {
      setMode(detectedMode);
    }
  }, [mode, setMode]);

  const currentMode = mode || "light";

  return (
    <div className="h-screen overflow-y-auto hide-scrollbar">
      <div className="flex flex-col min-h-screen">
        <div className="flex-1 flex relative">
          {/* Gradient Layer */}
          <div className={`absolute inset-0 z-0 ${currentMode}-bg opacity-95`}></div>

          {/* Background Image Layer */}
          <BackgroundImage mode={currentMode} />

          {/* Content Layer */}
          <div className="relative z-20 flex-1 flex flex-col">
            <div className="flex-1 p-4 flex flex-col">
              {/* 1. Language selector at the top */}
              <div className="flex justify-center">
                <LanguageSelector />
              </div>

              {/* 2. Sangati text and title right under language selector */}
              <Title mode={currentMode} />

              {/* 3. Description right under the title */}
              <Description mode={currentMode} />

              {/* 4. Begin button in the middle */}
              <div className="flex-1 flex justify-center items-center">
                <BeginButton mode={currentMode} />
              </div>

              {/* 4. Login section at the bottom */}
              <LoginButton mode={currentMode} />
            </div>
          </div>
        </div>
        {/* Company text at the bottom of the page */}
        <Company />
      </div>
      {/* Footer below the page */}
      <ContactFooter />
    </div>
  );
};

export default Home;
